<template>
    <Dialog
            :open="open"
            :title="title"
            max-width="1000px"
            @close="$emit('close')">
        <v-form ref="zoneForm" v-model="valid">
            <v-row>
                <v-col cols="12">
                    <div class="d-flex align-center">
                        <v-text-field
                                v-model="search"
                                class="datatable-search"
                                dense
                                hide-details
                                outlined
                                prepend-inner-icon="mdi-magnify"/>
                    </div>
                    <v-data-table
                            v-model="selectedUsers"
                            :headers="header"
                            :items="users"
                            :loading="loading"
                            :search="search"
                            class="rounded-lg shadow my-6"
                            item-key="UserID"
                            show-select>
                        <template v-slot:[`item.AvatarUrl`]="{item}">
                            <v-avatar size="35">
                                <img
                                        v-if="item.AvatarUrl"
                                        :src="item.AvatarUrl"
                                        alt="avatar">
                                <v-icon v-else size="50">
                                    mdi-account-circle
                                </v-icon>
                            </v-avatar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            class=" py-6 secondary--text shadow-inverse mr-5"
                            color="primary"
                            depressed
                            @click="$emit('close')">
                        {{ $t('close') }}
                    </v-btn>
                    <v-btn
                            :disabled="selectedIDs.length === 0"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="save">
                        {{ $t('add') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";
import {ZONE_USER_MONITORED} from "@/helper/constants";

export default {
  name: "ZoneManagementAddUsers",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    users: {
      type: Array,
      required: true
    },
    userType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      valid: false,
      availableUsers: [],
      selectedUsers: [],
      search: '',
    };
  },
  computed: {
    title() {
      return this.userType === ZONE_USER_MONITORED ? this.$t('zones.addMonitoredMembers') : this.$t('zones.addNotificationReceivers');
    },
    header() {
      return [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl'},
        {text: this.$t('authentication.firstName'), value: 'FirstName'},
        {text: this.$t('authentication.lastName'), value: 'LastName'},
        {text: this.$t('authentication.email'), value: 'Email'},
      ];
    },
    selectedIDs() {
      return this.selectedUsers.map((user) => user.UserID);
    }
  },
  watch: {
    users: {
      handler(users) {
        this.availableUsers = users;
      },
      deep: true,
    }
  },
  methods: {
    save() {
      this.$emit('save', this.selectedIDs);
      this.selectedUsers = [];
    }
  }
};
</script>

<style scoped>

</style>